import ServicesRelatedList from './ServicesRelatedList';

export { type ServicesRelatedListProps } from './ServicesRelatedList';
export default ServicesRelatedList;
